import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const row1 = [{
  quote: 'Con SIC 360 logré que los chicos por fin conecten los conceptos. Las clases ya están armadas, lo que me ahorra horas de planificación los fines de semana. Nunca pensé que un material me podía cambiar tanto la rutina.',
  name: 'María González, 39 años',
  role: 'Docente de SIC y Economía · Córdoba'
}, {
  quote: 'Después de años dando SIC improvisando con fotocopias sueltas, este sistema me dio estructura. El Resolucionario es oro puro: ya sé exactamente qué respuesta esperar y cómo explicarla.',
  name: 'Rodrigo Sánchez, 44 años',
  role: 'Docente de Administración · Buenos Aires'
}, {
  quote: 'Los proyectos del Tomo 6 son lo mejor que le pasó a mis clases de quinto año. Los chicos trabajan en equipo, debaten y entregan algo concreto. Ya no me preguntan para qué sirve esto.',
  name: 'Valeria Gómez, 36 años',
  role: 'Docente de SIC II · Rosario'
}, {
  quote: 'Recién empiezo a dar SIC y estaba perdida con la planificación. El Mapa Anual me salvó. Supe exactamente qué tomo abrir cada mes desde el primer día de clases.',
  name: 'Camila Torres, 28 años',
  role: 'Docente novel · La Plata'
}];
const row2 = [{
  quote: 'El resolucionario me salvó la vida. Ya no pierdo horas corrigiendo sin saber si está bien.',
  name: 'Lucía Fernández, 32 años',
  role: 'Docente de SIC · Mendoza'
}, {
  quote: 'Mis alumnos de adultos por fin entienden las variaciones patrimoniales. Las actividades son claras y progresivas.',
  name: 'Jorge Medina, 51 años',
  role: 'Docente de SIC · Tucumán'
}, {
  quote: 'Lo mejor es el Mapa Anual. Llegué a marzo sabiendo exactamente qué dar cada semana.',
  name: 'Florencia Ruiz, 30 años',
  role: 'Docente novel · Santa Fe'
}, {
  quote: 'Doy SIC en tres escuelas distintas y este material me unificó todo. Mismo nivel, misma calidad en todos lados.',
  name: 'Hernán Domínguez, 42 años',
  role: 'Docente de Contabilidad · Bahía Blanca'
}, {
  quote: 'Las Clases Salvavidas son geniales. Más de una vez llegué sin nada preparado y salí del paso con calidad.',
  name: 'Mariela Sosa, 37 años',
  role: 'Docente de Administración · Salta'
}];
function ScrollRow({
  items,
  label
}: {
  items: typeof row1;
  label: string;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = scrollRef.current.offsetWidth * 0.75;
    scrollRef.current.scrollBy({
      left: dir === 'left' ? -amount : amount,
      behavior: 'smooth'
    });
  };
  return <div className="relative group" data-id="element-136">
      {/* Scroll buttons */}
      <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-8 h-8 bg-white shadow-lg rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 opacity-0 group-hover:opacity-100 transition-opacity hidden md:flex" data-id="element-137">
        <ChevronLeft size={18} data-id="element-138" />
      </button>
      <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-8 h-8 bg-white shadow-lg rounded-full flex items-center justify-center text-slate-600 hover:text-slate-900 opacity-0 group-hover:opacity-100 transition-opacity hidden md:flex" data-id="element-139">
        <ChevronRight size={18} data-id="element-140" />
      </button>

      <div ref={scrollRef} className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-2 -mx-1 px-1" style={{
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-141">
        {items.map((t, i) => <div key={i} className="snap-start shrink-0 w-[280px] md:w-[320px] bg-slate-50 border border-slate-200 rounded-xl p-4 flex flex-col" data-id="element-142">
            <div className="flex gap-0.5 mb-2" data-id="element-143">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="text-yellow-400 fill-yellow-400" size={12} data-id="element-144" />)}
            </div>
            <p className="text-xs md:text-sm text-slate-700 italic mb-3 flex-1 leading-relaxed" data-id="element-145">
              "{t.quote}"
            </p>
            <div data-id="element-146">
              <p className="font-bold text-slate-900 text-xs" data-id="element-147">{t.name}</p>
              <p className="text-[10px] text-slate-500" data-id="element-148">{t.role}</p>
            </div>
          </div>)}
      </div>
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-10 md:py-16 bg-white overflow-hidden" data-id="element-149">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-6 md:mb-10" data-id="element-151">
          <h2 className="text-xs font-bold tracking-widest text-[#1a365d] uppercase mb-2" data-id="element-152">
            TESTIMONIOS
          </h2>
          <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900" data-id="element-153">
            Lo que dicen otros docentes
          </h3>
        </div>

        <div className="space-y-4" data-id="element-154">
          <ScrollRow items={row1} label="Fila 1" data-id="element-155" />
          <ScrollRow items={row2} label="Fila 2" data-id="element-156" />
        </div>
      </div>
    </section>;
}